module.exports = __webpack_public_path__ + "static/silhouette-1-b80abb0bf3224c9948f04a637717b986.jpg";